import './QuizzesTheme.scss';

import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';
import listDefaultIcon from '../assets/default_img_quizzes.svg';
import iconBlack from '../assets/ic-quizzes-black.svg';
import emptyIcon from '../assets/ic-quizzes-empty.svg';
import iconWhite from '../assets/ic-quizzes-white.svg';

export const QuizzesTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-quizzes',
    backgroundColor: '#0d47a1',
    permissionIcon: iconBlack,
    permissionSelectedIcon: iconWhite,
    navbarIcon: iconWhite,
    listDefaultIcon,
    emptyIcon,
};
